import React, { useState, useEffect } from 'react';
import '../Hero.css';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [intervalId, setIntervalId] = useState(null);

  const slides = [
    {
      id: 1,
      title: (
        <>
          40 Years of Experience,<br />
          Proven by Quality.
        </>
      ),
      backgroundImage: "/main/main1.jpg"
    },
    {
      id: 2,
      title: (
        <>
          100% Domestic Production &<br />
          Largest Production Capacity
        </>
      ),
      backgroundImage: "/main/main2.jpg"
    },
    {
      id: 3,
      title: (
        <>
          Achieving Customer Satisfaction<br />
          Through Sweat and Effort.
        </>
      ),
      backgroundImage: "/main/main3.JPG"
    },
    {
      id: 4,
      title: (
        <>
          From Small Heat Exchangers<br />
          to Large Plant Equipment
        </>
      ),
      backgroundImage: "/main/main4.jpg"
    },
    {
      id: 5,
      title: (
        <>
          Leading District Heating Equipment,<br />
          Taibong Industrial Technology
        </>
      ),
      backgroundImage: "/main/main5.jpg"
    },
    {
      id: 6,
      title: (
        <>
          Adding Responsibility to Technological Innovation,<br />
          Designing a Sustainable Future.
        </>
      ),
      backgroundImage: "/main/main6.jpg"
    },
    {
      id: 7,
      title: (
        <>
          Southern Business Office<br />
          (Pohang Factory)
        </>
      ),
      backgroundImage: "/main/main7.JPG"
    }
  ];

  // 자동 슬라이드 시작 함수
  const startAutoSlide = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    const newIntervalId = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // 5초마다 자동 슬라이드
    setIntervalId(newIntervalId);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
    startAutoSlide(); // 타이머 초기화
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    startAutoSlide(); // 타이머 초기화
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
    startAutoSlide(); // 타이머 초기화
  };

  // 자동 슬라이드 기능
  useEffect(() => {
    startAutoSlide();
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [slides.length]);


  return (
    <section className="hero en-hero">
      <div className="hero-container">
        <div className="hero-slider">
          <div className="hero-slides" style={{ transform: `translateX(-${currentSlide * (100/7)}%)` }}>
            {slides.map((slide) => (
              <div key={slide.id} className="hero-slide" style={{ backgroundImage: `url(${slide.backgroundImage})` }}>
                <div className="hero-overlay"></div>
                <div className="hero-content">
                  <h1 className="hero-title">{slide.title}</h1>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          {slides.length > 1 && (
            <>
              <button className="hero-arrow hero-arrow-left" onClick={prevSlide}>
                <span>‹</span>
              </button>
              <button className="hero-arrow hero-arrow-right" onClick={nextSlide}>
                <span>›</span>
              </button>
            </>
          )}

          {/* Slide Indicators */}
          {slides.length > 1 && (
            <div className="hero-indicators">
              {slides.map((_, index) => (
                <button
                  key={index}
                  className={`hero-indicator ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => goToSlide(index)}
                />
              ))}
            </div>
          )}

        </div>
      </div>
    </section>
  );
};

export default Hero;
